import { Container } from '@pixi/react'
import { ControlGroup } from './ControlGroup'
import {
  AutoPanel,
  autoPlayService,
  CurrentTime,
  FeatureToggleV2Type,
  FixedContainerV2,
  GameNameTag,
  ga4Info,
  getIsXinStar,
  RefNoDisplayPluginFeatureToggleV2,
  SessionTime,
  SessionTotalStakeFeatureToggleV2,
  SessionTotalWinFeatureToggleV2,
  SessionWinLoseFeatureToggleV2,
  t,
  useAutoPlayStore,
  useFeatureToggleV2,
} from '@slot-nx/core'
import { Slot } from './Slot'
import { Background } from './Background'
import { gameConfig } from '../config'
import { BalanceContainer } from './BalanceContainer'
import { StakeContainer } from './StakeContainer'
import { GodziDropControl } from './godziDrop/GodziDropControl'
import { GodziDropWrapper } from './godziDrop/GodziDropWrapper'
import { DesktopBackground } from './DesktopBackground'
import { Table } from './Table'
import { WinBoard } from './WinBoard'
import { Winbar } from './WinBar'
import { BuyBonusPopup } from './BuyBonusPopup'
import { WinningPanel } from './WinningPanel'
import { onSpin } from '../domain/spin/SpinUtil'
import { SceneSpine } from './Scene'
import { Voucher } from './voucher/Voucher'
import { ShareButton } from './ShareButton'

interface GameProps {
  isVisible: boolean
}

export const Game = ({ isVisible }: GameProps) => {
  const [isXinStarChannel] = getIsXinStar()
  const enableSessionTime = useFeatureToggleV2(FeatureToggleV2Type.enableSessionTime)
  const enableSessionWinLose = useFeatureToggleV2(FeatureToggleV2Type.displaySessionWinLose)
  const enableSessionTotalStake = useFeatureToggleV2(FeatureToggleV2Type.enableSessionTotalStake)
  const enableSessionTotalWin = useFeatureToggleV2(FeatureToggleV2Type.enableSessionTotalWin)

  return (
    <Container name="GameView" visible={isVisible}>
      <DesktopBackground />
      <FixedContainerV2 name="game" x={0} y={0} width={gameConfig.resolution.width} height={gameConfig.resolution.height}>
        <Background x={gameConfig.resolution.width / 2} y={gameConfig.resolution.height / 2} />
        <Table x={gameConfig.resolution.width / 2} y={gameConfig.resolution.height / 2} />
        <Slot />
        <WinBoard />
        <Winbar />
        <BalanceContainer x={-10} y={gameConfig.resolution.height - 362} />
        <StakeContainer x={gameConfig.resolution.width - 215} y={1580} />
        {/*
          HUD：必須在基礎遊戲畫面之後、但在 ControlGroup 與所有可開啟的彈窗之前，
          這樣彈窗打開時才會蓋住 HUD，而不是 HUD 浮在彈窗上面。
          之後新增任何 in-game 彈窗，都要放在這個區塊「後面」。
        */}
        <CurrentTime x={gameConfig.resolution.width - 80} y={30} />
        <GameNameTag name={t('siteTitle')} x={20} y={gameConfig.resolution.height - 40} />
        {enableSessionTime && <SessionTime x={gameConfig.resolution.width * 2 + 300} y={gameConfig.resolution.height - 70} />}
        {enableSessionWinLose && <SessionWinLoseFeatureToggleV2 x={gameConfig.resolution.width / 2} y={gameConfig.resolution.height - 12} />}
        {enableSessionTotalStake && <SessionTotalStakeFeatureToggleV2 x={gameConfig.resolution.width / 2 - 200} y={gameConfig.resolution.height - 12} />}
        {enableSessionTotalWin && <SessionTotalWinFeatureToggleV2 x={gameConfig.resolution.width / 2 + 200} y={gameConfig.resolution.height - 12} />}
        <ControlGroup x={0} y={gameConfig.resolution.height - 256} />
        <GodziDropControl />
        <AutoPanel
          borderColor="#ffffff"
          onConfirm={() =>
            autoPlayService.startAutoPlay(() => {
              onSpin()
              const autoPlayTotalTime = useAutoPlayStore.getState().current
              ga4Info.addEvent(`autoplay_${autoPlayTotalTime}`)
            })}
        />
        <Voucher />
        <BuyBonusPopup x={gameConfig.resolution.width / 2} y={gameConfig.resolution.height / 2} />
        <GodziDropWrapper />
        <WinningPanel />
        <SceneSpine />
        {!isXinStarChannel && <ShareButton x={340} y={1450} width={380} height={88} />}
      </FixedContainerV2>
      <RefNoDisplayPluginFeatureToggleV2 portraitResolution={gameConfig.resolution} />
    </Container>
  )
}
